import React from "react";
import { AvailableShortly } from "@/app/(custom-header)/botb-refer-a-friend/components/AvailableShortly";
// import {ExploreYourDecember} from "@/app/(custom-header)/botb-refer-a-friend/components/ExploreYourDecember";
import FounderBadge from "@/app/(custom-header)/botb-refer-a-friend/components/founderBadge";

export const ReferAFriendNotYetAvailable = (): React.ReactNode => {
  return (
    <>
      <FounderBadge />
      <AvailableShortly />
      {/*<ExploreYourDecember />*/}
    </>
  );
};
